/* eslint complexity: ["error", 40] */

import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Redirect} from 'react-router-dom';
import {Button, Container, Dropdown, DropdownButton, Fade, Form, Tabs, Tab} from 'react-bootstrap';
import {push} from 'connected-react-router';
import {Formik} from 'formik';
import DatePicker from 'react-datepicker';
import Dialog from 'react-bootstrap-dialog';
import queryString from 'query-string';
import CommonMetaTag from './common-meta-tag';
import {addPartnerVideoToPlayerArea, getPlayerPermanentVideos, getVideosStore, purchaseVideo, showPlayerHowPurchaseModal, purchasePartnerVideo, myVideoActiveTab, setPlayerVideoStoreActiveTab, showPlayerNewSubscriptionModal, rtvChannelSelected, permanentVideoSelected, showVideoHighlightModal} from '../actions/player';
import PlayerHowPurchase from './player-how-purchase';
import PlayerNewSubscription from './player-new-subscription';
import defaultFieldImage from '../images/default_field_image.png'
import {useTranslation} from 'react-i18next';
import Configuration from '../config';
import {subscriptionKind} from '../constants';
import * as api from '../api';
import {showMessage} from '../actions/messages';
import {getVideoFieldSport, isPickleballVideo} from '../util/video-sports';
import PlayerHighLight from './player-highlight';
import {specialEventSubscriptionIncludesVideo, subscriptionIsActive} from '../util/special-event-access';

const PlayerVideoStorePartner = ({
  token,
  selectedPartner,
  profile,
  goto,
  videosStore,
  videosStoreSoon,
  videosStorePartnerVideo,
  completeStoreVideoCopy,
  addPartnerVideoToPlayerArea,
  selectedPartnerFields,
  selectedPartnerServices,
  searchVideos,
  purchaseVideo,
  purchasePartnerVideo,
  rtvVideos,
  rtvPartnerVideos,
  subscriptions,
  showPlayerHowPurchaseModal,
  openSubscriptionForVideo,
  video,
  permanentVideos,
  permanentPartnerVideos,
  playerVideoStoreActiveTab,
  setActiveTab,
  selectedPermanentVideo,
  createStoreVideoAnalysis,
  location: {search}
}) => {
  const {t, i18n} = useTranslation();
  if (token === null) {
    return (
      <Redirect to="/login"/>
    );
  }

  const params = queryString.parse(search);
  const confirmMessage = price => (
    <div className="row">
      <div className="col-lg-12 mt-sm-2">
        <p>{t('CONFIRM_PURCHASE', {price: price})}</p>
        <button type="button" className="btn btn-link p-0" onClick={showPlayerHowPurchaseModal}>{t('MORE_INFO')}</button>
      </div>
    </div>
  );

  let dialog = null;
  const confirmPurchasePartnerVideo = (videoId, price) => () => {
    dialog.show({
      title: t('CONFIRM_PURCHASE_TITLE'),
      body: confirmMessage(price),
      actions: [
        Dialog.Action(
          t('YES'),
          () => purchasePartnerVideo(videoId),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('NO'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const isUpcomingStoreVideo = storeVideo => new Date(storeVideo.timestamp) > new Date();

  const formatVideoDuration = duration => {
    const seconds = Number(duration);
    if (!seconds) {
      return null;
    }
    return new Date(seconds * 1000).toISOString().slice(11, 19);
  };

  const formatVideoFileSize = filesize => {
    const size = Number(filesize);
    if (!size) {
      return null;
    }
    return `${(Math.floor(size) / 1000000000).toFixed(2)}GB`;
  };

  const showUpcomingStoreVideoInfo = () => {
    dialog.show({
      title: 'Evento non ancora iniziato',
      body: 'Questo evento non è ancora iniziato. Il video sarà disponibile quando la partita sarà iniziata e l’upload o l’elaborazione saranno completati.',
      actions: [
        Dialog.Action(
          t('OK'),
          null,
          'btn btn-secondary'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const showStoreVideoUnavailableInfo = errorCode => {
    const processingErrors = ['video_not_found', 'video_in_streaming', 'no_video', 'no_video_for_slot'];
    const processing = processingErrors.includes(errorCode);
    dialog.show({
      title: processing ? 'Video in elaborazione' : 'Video non disponibile',
      body: processing
        ? 'Il video è ancora in fase di upload o elaborazione. Riprova tra poco.'
        : 'La partita non è disponibile al momento.',
      actions: [
        Dialog.Action(
          t('OK'),
          null,
          'btn btn-secondary'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const getVideoRtvChannels = storeVideo => (
    Array.isArray(storeVideo.rtvChannels) ? storeVideo.rtvChannels : []
  );

  const hasActiveSubscriptionForVideo = storeVideo => {
    const channels = getVideoRtvChannels(storeVideo);
    if (!channels.length || !subscriptions || !Array.isArray(subscriptions.subscriptions)) {
      return false;
    }

    const channelIds = channels.map(channel => Number(channel.id));
    return subscriptions.subscriptions.some(subscription => {
      if (!subscription || !subscriptionIsActive(subscription)) {
        return false;
      }
      if (subscription.kind === subscriptionKind.rtvUnlimited) {
        return true;
      }
      if (
        Number(subscription.partner) !== Number(selectedPartner.uid) ||
        !channelIds.includes(Number(subscription.rtv_channel_id))
      ) {
        return false;
      }
      if (subscription.kind === subscriptionKind.rtvDedicated) {
        return true;
      }
      return specialEventSubscriptionIncludesVideo(subscription, storeVideo, channelIds);
    });
  };

  const isPurchased = slotId => {
    if (video.find(v => v.slotId === slotId)) {
      return true;
    }

    if (permanentVideos.find(v => v.slotId === slotId)) {
      return true;
    }

    if (rtvVideos && rtvVideos.find(v => v.id === slotId)) {
      return true;
    }
    
    return false;
  };

  const canWatchIncluded = storeVideo => isPurchased(storeVideo.id) || hasActiveSubscriptionForVideo(storeVideo);

  const copyStoreVideoToMyVideo = storeVideo => async () => {
    const res = await api.addVideoToPlayerArea(storeVideo.id, token);
    if (res.status === 200 || res.status === 201) {
      completeStoreVideoCopy();
      return;
    }
    showStoreVideoUnavailableInfo(res.json && res.json.error);
  };

  const showStoreVideoVisionOptions = storeVideo => () => {
    const channels = getVideoRtvChannels(storeVideo);
    const actions = [];

    if (channels.length > 0) {
      actions.push(Dialog.Action(
        t('SUBSCRIBE_TO_REPLAYERTV'),
        () => openSubscriptionForVideo(channels[0]),
        'btn btn_red_outline_rp'
      ));
    }

    actions.push(Dialog.Action(
      `${t('PURCHASE')} ${storeVideo.price} €`,
      () => purchaseVideo([storeVideo.id]),
      'btn btn-secondary'
    ));
    actions.push(Dialog.Action(
      t('CANCEL'),
      null,
      'btn btn_red_outline_rp'
    ));

    dialog.show({
      title: t('CHOOSE_HOW_TO_WATCH_MATCH'),
      body: (
        <div>
          <p>
            {t('BUY_MATCH_INDIVIDUALLY')}
            {channels.length > 0
              ? t('OR_CHOOSE_LINKED_REPLAYERTV_SUBSCRIPTION')
              : '.'}
          </p>
          {channels.length > 0 && (
            <p>
              {t('ACTIVE_REPLAYERTV_SUBSCRIPTION_VIDEO_INCLUDED')}
            </p>
          )}
        </div>
      ),
      actions,
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const renderStoreVideoCard = storeVideo => {
    const duration = formatVideoDuration(storeVideo.duration);
    const fileSize = formatVideoFileSize(storeVideo.filesize);
    const channels = getVideoRtvChannels(storeVideo);
    const canWatch = canWatchIncluded(storeVideo);
    const fieldSport = getVideoFieldSport(storeVideo);
    const pickleballVideo = isPickleballVideo(storeVideo);

    return (
      <div
        key={storeVideo.id}
        className="col-md-12 col-lg-4 mb-sm-4 card-group"
        data-field-sport={fieldSport}
        data-pbvision-eligible={pickleballVideo}
      >
        <div className="card public-partner-match-card videostore-modern-card h-100">
          <div className="public-partner-match-card-accent"/>
          <div className="card-body d-flex flex-column">
            <div className="public-partner-match-heading">
              <div className="public-partner-match-heading-content">
                <div className="public-partner-match-badges">
                  <span className="badge badge-info">{t('VIDEO_STORE')}</span>
                  {isUpcomingStoreVideo(storeVideo) && <span className="badge badge-light">{t('COMING_SOON')}</span>}
                </div>
                <h5 className="public-partner-match-title">
                  {storeVideo.description || storeVideo.fieldName || selectedPartner.name}
                </h5>
              </div>
            </div>
            <div className="public-partner-match-details">
              <div className="public-partner-match-detail public-partner-match-detail-date">
                <span>{t('DATE_AND_TIME')}</span>
                <strong>{new Date(storeVideo.timestamp).toLocaleDateString(i18n.language)} {new Date(storeVideo.timestamp).toLocaleTimeString(i18n.language, {hour: '2-digit', minute: '2-digit'})}</strong>
              </div>
              {storeVideo.fieldName && (
                <div className="public-partner-match-detail">
                  <span>{t('FIELD')}</span>
                  <strong>{storeVideo.fieldName}</strong>
                </div>
              )}
              {(duration || fileSize) && (
                <div className="public-partner-match-detail-group">
                  {duration && (
                    <div className="public-partner-match-detail">
                      <span>{t('DURATION')}</span>
                      <strong>{duration}</strong>
                    </div>
                  )}
                  {fileSize && (
                    <div className="public-partner-match-detail">
                      <span>{t('FILE_SIZE')}</span>
                      <strong>{fileSize}</strong>
                    </div>
                  )}
                </div>
              )}
            </div>
            {!canWatch && (
              <div className="public-partner-match-options">
                <div>
                  <small>{t('SINGLE_PURCHASE')}</small>
                  <strong>{storeVideo.price} €</strong>
                </div>
                {channels.length > 0 && (
                  <div>
                    <small>{t('ALSO_AVAILABLE_WITH')}</small>
                    <strong>{t('SUBSCRIPTION')}</strong>
                  </div>
                )}
              </div>
            )}
            <Button
              type="button"
              className="public-partner-match-action mt-auto"
              variant="primary"
              onClick={
                canWatch
                  ? isUpcomingStoreVideo(storeVideo)
                    ? showUpcomingStoreVideoInfo
                    : copyStoreVideoToMyVideo(storeVideo)
                  : showStoreVideoVisionOptions(storeVideo)
              }
            >
              {canWatch
                ? isUpcomingStoreVideo(storeVideo)
                  ? 'Evento non ancora iniziato'
                  : hasActiveSubscriptionForVideo(storeVideo)
                    ? "Guarda incluso nell'abbonamento"
                    : t('COPY_TO_MY_VIDEO')
                : 'Scopri le opzioni di visione'}
            </Button>
            {canWatch && !isUpcomingStoreVideo(storeVideo) && pickleballVideo && (
              <Button
                type="button"
                className="public-partner-match-action"
                variant="outline-primary"
                style={{marginTop: 8}}
                onClick={createStoreVideoAnalysis(storeVideo)}
              >
                Analisi della partita
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  };

  const isPartnerVideoPurchased = videoName => {
    if (permanentPartnerVideos.find(v => v.videoName === videoName)) {
      return true;
    }

    if (rtvPartnerVideos && rtvPartnerVideos.find(v => v.videoName === videoName)) {
      return true;
    }

    return false;
  };

  const setValueForField = (f, id) => {
    f('fieldId', id);
    f('serviceId', null);
  };

  const setValueForService = (f, id) => {
    f('fieldId', null);
    f('serviceId', id);
  };

  const getCoverImage = (partnerId, coverImage, defaultImage, videoId) => {
    if (coverImage && coverImage[0]) {
      return {backgroundImage: `url(${Configuration.apiEndPoint}/video_partners/${videoId}/images?load=${coverImage[0]}`, backgroundSize: 'cover'};
    }
    if (defaultImage && defaultImage[0]) {
      return {backgroundImage: `url(${Configuration.apiEndPoint}/images/${partnerId}?load=${defaultImage[0]}`, backgroundSize: 'cover'};
    }

    return {backgroundImage: defaultFieldImage, backgroundSize: 'cover'};;
  };

  return (
    <Fragment>
      <CommonMetaTag/>
      <Fade in appear className="bg_white" style={{transition: 'opacity 0.30s linear', minHeight: 1000}}>
        <Container fluid className="presentation-container">
          <div className="page-header header-filter clear-filter dashboard_hero_rp" data-parallax="true">
            <div className="dashboard_hero_overlay_rp"/>
          </div>
          <div className="main main_raised_rp">
            <div className="section">
              <div className="container">
                <div className="row mb-4">
                  <div className="col-12">
                    <div><h4 className="section_title_neg_rp">{t('VIDEO_STORE_PARTNER', {partner: selectedPartner.name})}</h4></div>
                    <Tabs defaultActiveKey={selectedPartner.isSpecialist ? "partner_video" : "replayer_video"} className="myvideo-tabs" style={{marginTop: 20}}>
                      <Tab eventKey="replayer_video" title={t('REPLAYER_VIDEOS')} tabClassName="myvideo-tab">
                        <div className="row mb-4">
                          {selectedPartnerFields.filter(f => f.recording).length ?
                          <div className="col-12">
                            <div className="detail_head_rp video_store_head rounded" style={{background: '#0c213d'}}>
                              <div>
                                <Formik
                                  enableReinitialize
                                  initialValues={{partnerUid: selectedPartner.uid, fieldId: params.fieldId ? Number(params.fieldId) : null, serviceId: params.serviceId ? Number(params.serviceId) : null, fromDatetime: params.fromDatetime ? new Date(params.fromDatetime).toISOString() : null, toDatetime: params.toDatetime ? new Date(params.toDatetime).toISOString() : null}}
                                  onSubmit={searchVideos}
                                >
                                  {({
                                    handleSubmit,
                                    handleChange,
                                    setFieldValue,
                                    values
                                  }) => {
                                    return (
                                      <Form className="d-flex flex-wrap" onSubmit={handleSubmit}>
                                        <div className="mr-md-4 video_store_head_filter_button">
                                          <label className="mr-1">{t('FIELD_GYM_POOL')}</label>
                                          <DropdownButton className="video_store_dropdown" title={values.fieldId === null && values.serviceId === null? t('SELECT') : values.serviceId === null ? selectedPartnerFields.find(sf => sf.id === values.fieldId).name : selectedPartnerServices.find(ss => ss.id === values.serviceId).name}>
                                            {
                                              selectedPartnerFields.map(f => (
                                                f.recording?
                                                <Dropdown.Item key={f.id} href="#" onClick={() => setValueForField(setFieldValue, f.id)}>{f.name}</Dropdown.Item>
                                                :null
                                              ))
                                            }
                                            {
                                              selectedPartnerServices.map(s => (
                                                s.recording?
                                                <Dropdown.Item key={s.id} href="#" onClick={() => setValueForService(setFieldValue, s.id)}>{s.name}</Dropdown.Item>
                                                :null
                                              ))
                                            }
                                          </DropdownButton>
                                        </div>
                                        <label className="mr-1">{t('PERIOD')}</label>
                                        <Form.Group>
                                          <DatePicker
                                            showTimeSelect
                                            locale="it"
                                            className="form-control"
                                            timeFormat="HH:mm"
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            dropdownMode="select"
                                            selected={(values.fromDatetime && new Date(values.fromDatetime)) || null}
                                            onChange={val => setFieldValue('fromDatetime', val ? val.toISOString() : val)}/>
                                        </Form.Group>
                                        <Form.Group>
                                          <DatePicker
                                            showTimeSelect
                                            locale="it"
                                            className="form-control"
                                            timeFormat="HH:mm"
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            dropdownMode="select"
                                            minTime={new Date().setHours(0,30)}
                                            maxTime={new Date().setHours(23,59)}
                                            selected={(values.toDatetime && (new Date(values.toDatetime).getHours() === 0 && new Date(values.toDatetime).getMinutes() === 0 ? new Date(values.toDatetime).setHours(23,59) : new Date(values.toDatetime))) || null}
                                            onChange={val => setFieldValue('toDatetime', val ? val.getHours() === 0 && val.getMinutes() === 0 ? new Date(val.setHours(23,59)).toISOString() : val.toISOString() : val)}/>
                                        </Form.Group>
                                        <div className="ml-auto ml-lg-0">
                                          <button type="submit" className="btn btn_red_rp video_store_head_filter_button">{t('FIND')}</button>
                                        </div>
                                        <div className="ml-auto mr-lg-0">
                                          <Button
                                            type="button"
                                            className="btn btn_blue_rp video_store_head_filter_button"
                                            onClick={() => searchVideos({partnerUid: selectedPartner.uid, fieldId: values.fieldId ? Number(values.fieldId) : null, serviceId: values.serviceId ? Number(values.serviceId) : null, fromDatetime: values.fromDatetime ? new Date(values.fromDatetime).toISOString() : null, toDatetime: values.toDatetime ? new Date(values.toDatetime).toISOString() : null})}
                                          >
                                            {t('UPDATE_VIDEOS')}
                                          </Button>
                                        </div>
                                      </Form>
                                    );
                                  }}
                                </Formik>
                              </div>
                              <hr className="hr_blue"/>
                              <div className="row">
                                <div className="col-lg-12 mt-sm-2">
                                  <p>{t('CHOOSE_VIEW_PREMIERE_AND_BUY_FULL_VIDEO')} <button type="button" className="btn btn-link p-0" style={{color: 'white', textDecoration: 'underline', verticalAlign: 'baseline'}} onClick={showPlayerHowPurchaseModal}>{t('COST_DEDUCT_FROM_REPLAYER_CREDIT')}</button>{" " + t('CHOOSE_VIEW_PREMIERE_AND_BUY_FULL_VIDEO_TWO')}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          :
                          selectedPartnerFields.filter(f => f.recording).length ?
                          <div className="col-lg-12 mt-sm-2 text-center" style={{paddingTop: 50}}>
                            <p><h5>{t('NO_VIDEO')}</h5></p>
                          </div>
                          : null}
                        </div>
                        <Tabs activeKey={playerVideoStoreActiveTab} className="videostore-tabs" style={{marginTop: 20}} onSelect={t => setActiveTab(t)}>
                          <Tab eventKey="watch_now" title={t('WATCH_NOW')} tabClassName="videostore-tab"> 
                            <div className="row">
                              {
                                videosStore && videosStore.length > 0 ?
                                  videosStore.map(renderStoreVideoCard)
                                : <Fragment>
                                      <div className="col-lg-12 mt-sm-2 text-center" style={{background: '#00152f50', paddingTop: 15}}>
                                        <p><h5>{t('NO_VIDEO')}</h5></p>
                                      </div>
                                  </Fragment>
                              }
                            </div>
                          </Tab>
                          <Tab eventKey="soon" title={t('SOON')} tabClassName="videostore-tab"> 
                            <div className="row">
                              {
                                videosStoreSoon && videosStoreSoon.length > 0 ?
                                  videosStoreSoon.map(renderStoreVideoCard)
                                : <Fragment>
                                      <div className="col-lg-12 mt-sm-2 text-center" style={{background: '#00152f50', paddingTop: 15}}>
                                        <p><h5>{t('NO_VIDEO')}</h5></p>
                                      </div>
                                  </Fragment>
                              }
                            </div>
                          </Tab>
                        </Tabs>
                      </Tab>
                      <Tab eventKey="partner_video" title={t('PARTNER_VIDEOS')} tabClassName="myvideo-tab">
                        <div className="row mb-4">
                          <div className="col-12">
                            <div className="detail_head_rp video_store_head rounded" style={{background: '#0c213d'}}>
                              <div className="row">
                                <div className="col-lg-12 mt-sm-2">
                                  <p>{t('CHOOSE_VIEW_PREMIERE_AND_BUY_FULL_VIDEO')} <button type="button" className="btn btn-link p-0" style={{color: 'white', textDecoration: 'underline', verticalAlign: 'baseline'}} onClick={showPlayerHowPurchaseModal}>{t('COST_DEDUCT_FROM_REPLAYER_CREDIT')}</button>{" " + t('CHOOSE_VIEW_PREMIERE_AND_BUY_FULL_VIDEO_PARTNER')}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          {
                            videosStorePartnerVideo && videosStorePartnerVideo.length > 0 ?
                              videosStorePartnerVideo.map(v => (
                              <div key={v.id} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                                <div className="card video_partner_card_bg_rp">
                                  <div className="video_card_image" style={getCoverImage(v.partnerId, v.coverImage, v.defaultImage, v.videoId)}>
                                    <div className="videoWrapper"/>
                                  </div>
                                  <div className="card-body d-flex flex-column card_border_bottom_white">
                                    <h5 className="card-title">{v.title}</h5>
                                    <p className="lightblue_text mb-4">
                                      {selectedPartner.name}
                                    </p>
                                    <p className="lightblue_text mb-4">
                                      {v.description}
                                    </p>
                                    <p className="lightblue_text mb-4">
                                    {t('FILE_SIZE')}: {(Math.floor(v.filesize)/(1000000000)).toFixed(2)}GB
                                    </p>
                                  </div>
                                  <div style={{display: 'flex', justifyContent: !isPartnerVideoPurchased(v.videoName) ? 'space-between' : 'flex-end', padding: 15}}>
                                    {
                                      !isPartnerVideoPurchased(v.videoName) ?
                                      <div style={{paddingTop: 7}}>
                                        <span className="bold_title_rp mr-2">{t('PRICE')}:</span>{v.videoPrice} €
                                      </div>
                                      : null
                                    }
                                      <div>
                                        {
                                        isPartnerVideoPurchased(v.videoName) ?
                                          <button type="button" data-toggle="modal" className="btn btn_red_rp" onClick={addPartnerVideoToPlayerArea(v.videoId)}>{t('COPY_TO_MY_VIDEO')}</button>
                                        : <button type="button" data-toggle="modal" className="btn btn_red_rp" onClick={confirmPurchasePartnerVideo(v.videoId, v.videoPrice)}>{t('PURCHASE')}</button>
                                        }
                                      </div>
                                  </div>
                                </div>
                              </div>
                            ))
                            : <Fragment>
                                  <div className="col-lg-12 mt-sm-2 text-center" style={{background: '#00152f50', paddingTop: 15}}>
                                    <p><h5>{t('NO_VIDEO')}</h5></p>
                                  </div>
                              </Fragment>
                          }
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Fade>
      <PlayerHowPurchase/>
      <PlayerNewSubscription/>
      {
        selectedPermanentVideo === null ?
          null :
          <PlayerHighLight video={selectedPermanentVideo}/>
      }
      <Dialog
        ref={el => {
          dialog = el;
        }}/>
    </Fragment>
  );
};

PlayerVideoStorePartner.propTypes = {
  token: PropTypes.string,
  selectedPartner: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  goto: PropTypes.func.isRequired,
  videosStore: PropTypes.array,
  videosStoreSoon: PropTypes.array,
  completeStoreVideoCopy: PropTypes.func.isRequired,
  selectedPartnerFields: PropTypes.array,
  selectedPartnerServices: PropTypes.array,
  searchVideos: PropTypes.func.isRequired,
  purchaseVideo: PropTypes.func.isRequired,
  rtvVideos: PropTypes.array,
  rtvPartnerVideos: PropTypes.array,
  subscriptions: PropTypes.object,
  showPlayerHowPurchaseModal: PropTypes.func.isRequired,
  openSubscriptionForVideo: PropTypes.func.isRequired,
  video: PropTypes.array,
  permanentVideos: PropTypes.array,
  selectedPermanentVideo: PropTypes.object,
  createStoreVideoAnalysis: PropTypes.func.isRequired
};

PlayerVideoStorePartner.defaultProps = {
  token: null,
  videosStore: [],
  videosStoreSoon: [],
  selectedPartnerFields: [],
  selectedPartnerServices: [],
  video: [],
  permanentVideos: [],
  permanentPartnerVideos: [],
  rtvVideos: [],
  rtvPartnerVideos: [],
  subscriptions: null,
  selectedPermanentVideo: null
};

const mapStateToProps = ({login: {token, profile}, player: {selectedPartner, selectedPartnerFields, selectedPartnerServices, videosStore, videosStoreSoon, video, permanentVideos, rtvVideos, rtvPartnerVideos, videosStorePartnerVideo, permanentPartnerVideos, playerVideoStoreActiveTab, subscriptions, selectedPermanentVideo}}) => ({
  token,
  profile,
  selectedPartner,
  videosStore,
  videosStoreSoon,
  selectedPartnerFields,
  selectedPartnerServices,
  video,
  permanentVideos,
  permanentPartnerVideos,
  rtvVideos,
  rtvPartnerVideos,
  videosStorePartnerVideo,
  playerVideoStoreActiveTab,
  selectedPermanentVideo,
  subscriptions
});

const mapDispatchToProps = dispatch => ({
  completeStoreVideoCopy: () => {
    dispatch(showMessage('MY_VIDEO', 'VIDEO_ADDED'));
    dispatch(getPlayerPermanentVideos());
    dispatch(push('/player-video'));
  },
  addPartnerVideoToPlayerArea: videoId => () => {
    dispatch(addPartnerVideoToPlayerArea(videoId));
    dispatch(myVideoActiveTab("partner_videos"));
    dispatch(push('/player-video'));
  },
  purchaseVideo: slots => {
    dispatch(purchaseVideo(slots));
  },
  purchasePartnerVideo: videoId => {
    dispatch(purchasePartnerVideo(videoId));
  },
  searchVideos: filters => {
    dispatch(getVideosStore(filters.partnerUid, filters.fieldId, filters.serviceId, filters.fromDatetime, filters.toDatetime));
  },
  showPlayerHowPurchaseModal: () => {
    dispatch(showPlayerHowPurchaseModal());
  },
  openSubscriptionForVideo: rtvChannel => {
    dispatch(rtvChannelSelected(rtvChannel));
    dispatch(showPlayerNewSubscriptionModal());
  },
  setActiveTab: t => {
    dispatch(setPlayerVideoStoreActiveTab(t));
  },
  createStoreVideoAnalysis: storeVideo => event => {
    event.preventDefault();
    dispatch(permanentVideoSelected({
      videoId: null,
      slotId: storeVideo.id,
      contentType: 'store_slot',
      contentId: storeVideo.id,
      analysisMode: true,
      sliceHighlight: true,
      name: storeVideo.description || storeVideo.fieldName || 'Video Store',
      analysisTitle: `Analisi ${storeVideo.description || storeVideo.fieldName || 'Video Store'}`,
      token: storeVideo.token,
      cameras: storeVideo.cameras || [],
    }));
    dispatch(showVideoHighlightModal());
  },
  goto: (path, action = null) => e => {
    e.preventDefault();
    if (action) {
      dispatch(action());
    }

    dispatch(push(path));
  }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerVideoStorePartner));
